'use client';
import { cyrb53 } from '@s7/utils';
import { serializeTheme } from '../serializeTheme.js';

/* Хэш темы используется в механизме кэширования в createStyles */ const attachThemeHash = (theme)=>{
    const cleanSerializeTheme = serializeTheme(theme);
    theme.__hash = cyrb53(cleanSerializeTheme);
    return theme;
};

export { attachThemeHash };
//# sourceMappingURL=attachThemeHash.js.map
